import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import classNames from 'classnames'

import Icon from 'components/Icon'
import styles from './Breadcrumbs.module.css'

type ListProps = {
  className?: string
  isPreview?: boolean
  hasHomeCrumb?: boolean
}

export type BreadCrumbItem = {
  label: string
  href?: string
  as?: string
  icon?: string
}

export type BreadcrumbsProps = ListProps & {
  crumbs: BreadCrumbItem[]
}

const cx = classNames.bind(styles)

const Crumb = ({ href, as, label, icon }: BreadCrumbItem) => (
  <li className={styles.crumb}>
    {href ? (
      <Link href={href} as={as}>
        <a>
          {icon && <Icon kind={icon} size={14} color="currentColor" />}
          {label && label}
        </a>
      </Link>
    ) : (
      <span>
        {icon && <Icon kind={icon} size={14} color="currentColor" />}
        {label && label}
      </span>
    )}
  </li>
)

const Breadcrumbs = ({ crumbs, hasHomeCrumb = true, className }: BreadcrumbsProps) => (
  <div className={cx(styles.breadcrumbsContainer, className)}>
    <ul className={styles.breadcrumbs}>
      {hasHomeCrumb && <Crumb href="/" label="Home" />}
      {crumbs
        // convienience, just filter any blank crumbs
        .filter(crumb => crumb.label)
        .map(crumb => (
          <Crumb key={`crumb-${crumb.label}`} href={crumb.href} as={crumb.as} label={crumb.label} />
        ))}
    </ul>
  </div>
)

Breadcrumbs.propTypes = {
  crumbs: PropTypes.array.isRequired,
  isSticky: PropTypes.bool
}

Breadcrumbs.defaultProps = {
  isSticky: false
}

export default Breadcrumbs
